module.exports = __webpack_public_path__ + "img/copy.7ed69845.svg";